import { SidebarComponent } from "./sidebar/sidebar.component";
import { NavbarComponent } from "./navbar/navbar.component";
import { PaginatorComponent } from "./paginator/paginator.component";
import { SearchBoxComponent } from "./search-box/search-box.component";
import { FormErrorComponent } from "./form-error/form-error.component";
import { NgModule } from "@angular/core";
import { ChangePasswordDialogComponent } from "./change-password-dialog/change-password-dialog.component";
import { ImageComponent } from "./image/image.component";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BackButtonComponent } from "./back-button/back-button.component";
import { LoaderComponent } from "./loader/loader.component";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { DateRangePickerComponent } from "./date-range-picker/date-range-picker.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { CollapseViewComponent } from "./collapse_view/collapse-view/collapse-view.component";
import { SkeletonTableComponent } from "./skeleton-table/skeleton-table.component";
import { SkeletonCardComponent } from "./skeleton-card/skeleton-card.component";

@NgModule({
  declarations: [
    SidebarComponent,
    SearchBoxComponent,
    PaginatorComponent,
    NavbarComponent,
    DateRangePickerComponent,
    FormErrorComponent,
    ChangePasswordDialogComponent,
    ImageComponent,
    BackButtonComponent,
    LoaderComponent,
    CollapseViewComponent,
    SkeletonTableComponent,
    SkeletonCardComponent,
  ],
  exports: [
    SidebarComponent,
    SearchBoxComponent,
    DateRangePickerComponent,
    NavbarComponent,
    FormErrorComponent,
    ChangePasswordDialogComponent,
    ImageComponent,
    BackButtonComponent,
    CollapseViewComponent,
    LoaderComponent,
    SkeletonTableComponent,
    SkeletonCardComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PerfectScrollbarModule,
    NgbModule,
    NgxDaterangepickerMd.forRoot(),
  ],
})
export class SharedModule {}
